module.exports = __webpack_public_path__ + "static/Raleway-Light-6c084270ccdeb72fd9f5a5144cea628f.ttf";